import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from 'types';
import {
  selectSectorOptions,
  selectStageOptions,
  selectStartupDetails,
  selectStartupProgramOptions,
} from 'redux/selectors/startups';
import {
  getStartupById,
  getStartupSectors,
  getStartupStages,
  getStartupPrograms,
  updateStartupById,
} from 'redux/actions/startups';
import { selectUserStartupId, selectUserType } from 'redux/selectors/auth';
import { setDrawerBody, setIsDrawerOpen } from 'redux/actions/workspace';

const mapStateToProps = (state: StateType) => ({
  selectedStartup: selectStartupDetails(state),
  sectorOptions: selectSectorOptions(state),
  stageOptions: selectStageOptions(state),
  startupProgramOptions: selectStartupProgramOptions(state),
  userStartupId: selectUserStartupId(state),
  userType: selectUserType(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getStartupById,
    updateStartupById,
    getStartupSectors,
    getStartupStages,
    getStartupPrograms,
    setDrawerBody,
    setIsDrawerOpen,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
